import React, { useCallback } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import MobileInput from 'modules/views/shared/MobileInput';
import { FieldWrapper, IField } from 'modules/views/pages/PersonalInformation/components/fieldWrapper';

import { IProfileInformationSchema } from '../schema';
import { useStyles } from '../styles';

interface IEmergencyPhoneField {
  isRequired: boolean;
  name: string;
}

interface IEmergencyContactSectionProps {
  emergencyContactFields: IField[];
  emergencyPhoneField: IEmergencyPhoneField;
  values: IProfileInformationSchema;
  errors: Record<string, { message: string } | undefined>;
  setValue: (key: keyof IProfileInformationSchema, value: any) => void;
}

const EmergencyContactSection: React.FC<IEmergencyContactSectionProps> = ({
  emergencyContactFields,
  emergencyPhoneField,
  values,
  errors,
  setValue,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handlePhoneChange = useCallback(
    ({ phone }: { phone: string; inputValue: string; country: any }) => {
      setValue('emergencyContactNumber', phone);
    },
    [setValue],
  );

  return (
    <>
      <p className={classes.sectionTitle} data-testid="profile-section-title-emergency-contact">
        {t('contactInformation.emergencyContact.title')}
      </p>
      <Grid container spacing={3} data-testid="profile-section-emergency-contact">
        {emergencyContactFields.map((field, index) => (
          <Grid item xs={12} md={6} lg={4} key={field.id}>
            <FieldWrapper
              field={field}
              index={index}
              value={values[field.id]}
              setValue={value => setValue(field.id as keyof IProfileInformationSchema, value)}
              error={errors[field.id]?.message}
              options={field.options}
            />
          </Grid>
        ))}
        <Grid item xs={12} md={6} lg={4}>
          <MobileInput
            label={emergencyPhoneField.name}
            required={emergencyPhoneField.isRequired}
            testId="emergencyContactNumber-input"
            autoComplete="new-password"
            value={values.emergencyContactNumber}
            error={errors.emergencyContactNumber?.message}
            onChange={handlePhoneChange}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default EmergencyContactSection;
